import { dateColumn } from "..";

const createdAtColumn = (Header = "Created On") => dateColumn("createdAt", Header);

export default createdAtColumn;
